module.exports = __webpack_public_path__ + "img/en-US.c5158b17.svg";